// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmTable = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			wrapper: 'table-wrapper'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			$context.wrap( "<div class='" + settings.wrapper + "'></div>" );

			$("a.top15btn").on("click", function(event){
				event.preventDefault();

				if( 0 ===  $("tr.qualified-true").length ) {
					if( 0 === $("tr.no-quals").length ){
						$("table.table.table--standings tbody").append('<tr class="no-quals"><td></td><th>No qualified drivers at this time.</th><td></td><td></td></tr>');
					}
				}
				var targetId = event.target.id;
				if("top15" == targetId) {
					$("table.table.table--standings").addClass("table--top15");
					$('#top15').removeClass("tab-nav__link--active").addClass("tab-nav__link--active");
					$('#top15-all').removeClass("tab-nav__link--active");

					$('tr.qualified-true:gt(14), tr.qualified-false').addClass('not-top-15');
					$('tr th.table__divider').slideToggle();

					$('table.table.table--standings tbody tr[class*=qualified-]:visible').each(function(i) {
						var idx = (i < 9 ? "0" : "") + (i + 1);
						$(this).children("th").text(idx);

						if (i % 2 === 0) { /* we are even */
							$(this).addClass( "is-top-15" ).addClass("odd");
						}
						else {
							$(this).addClass( "is-top-15" ).addClass("even");
						}
						i++;
					});

				} else {

					$("table.table.table--standings").removeClass("table--top15");
					$('#top15-all').removeClass("tab-nav__link--active").addClass("tab-nav__link--active");
					$('#top15').removeClass("tab-nav__link--active");

					$('tr.qualified-true:gt(14), tr.qualified-false').removeClass('not-top-15');
					$('tr th.table__divider').slideToggle();

					// remove #no-quals row
					$(".no-quals").remove();

					$('table.table.table--standings tbody tr').each(function(i) {

						if (i % 2 === 0) { /* we are even */
							$(this).removeClass( "is-top-15" ).removeClass("odd");
						}
						else {
							$(this).removeClass( "is-top-15" ).removeClass("odd");
						}

						i++;
					});

					$("table.table.table--standings tbody tr th").each(function(i, val){
						var idx = (i < 9 ? "0" : "") + (i + 1);
						$(this).text(idx);
						}
					);
				}

			});

			$("document").ready(function() {
				setTimeout(function() {
					var target_btn = "#top15";
					if( 0 ===  $("tr.qualified-true").length ) {
						target_btn = "#top15-all";
						$(".top15-container").hide();
					}
					$( target_btn ).triggerHandler("click");
				},250);
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}
	};
}(jQuery));